export const candidateData = {
  name: "Dr. Subhashini G",
  title: "Advocate",
  licenseNumber: "TS/446/1998",
  election: "Telangana Bar Council Elections 2026",
  
  heroSection: {
    mainHeadline: "WHEN WOMEN ARE REPRESENTED",
    subHeadline: "THE PROFESSION BECOMES STRONGER",
    tagline: "Standing with you. Speaking for you.",
    ctaText: "Support Our Vision",
    image: "https://customer-assets.emergentagent.com/job_90bc38f9-3060-400d-9611-cbf37a877254/artifacts/0qr7ax7w_ChatGPT%20Image%20Jan%2027%2C%202026%2C%2010_59_57%20AM.png"
  },

  about: {
    image: "https://customer-assets.emergentagent.com/job_90bc38f9-3060-400d-9611-cbf37a877254/artifacts/w3st1m02_ChatGPT%20Image%20Jan%2027%2C%202026%2C%2012_34_16%20PM.png",
    title: "Dr. Subhashini G",
    description: "A dedicated legal professional with over 28 years of continuous practice at the Telangana High Court Bar. Dr. Subhashini G has been a champion for women's rights, junior advocates, and the modernization of legal practice.",
    highlights: [
      "Ph.D. in Law with strong academic foundation",
      "28+ years of continuous practice at the Bar",
      "Telangana State President, Human Rights Council",
      "National Youth Awardee (Govt. of India)",
      "Formal training in ADR & Family Dispute Resolution from NALSAR",
      "40 years of social work experience"
    ]
  },

  vision: {
    title: "A Vision for Stronger Bar Council",
    subtitle: "Committed to Justice, Dignity, and Reform",
    statement: "I envision a legal fraternity where every advocate, from the newest junior to the most experienced senior is supported, respected, and empowered. A Bar Council that is modern, efficient, and truly serves its members."
  },

  commitments: [
    {
      icon: "Shield",
      title: "Protect Women's Reservation",
      description: "Vigilantly uphold the 30% women's reservation and ensure it is not undermined by co-option for political gain. Genuine leadership opportunities for women advocates."
    },
    {
      icon: "DollarSign",
      title: "Minimum Stipend for Young Advocates",
      description: "Fight for state-mandated stipends for junior advocates to combat brain drain and support emerging legal talent during their crucial early years."
    },
    {
      icon: "Monitor",
      title: "Digital Infrastructure",
      description: "Create a Paperless Bar Office for efficient enrollment, verification, and renewals. Save time and avoid frustrating delays with modern technology."
    },
    {
      icon: "FileSearch",
      title: "Enhance Disciplinary Transparency",
      description: "Enable online tracking of disciplinary proceedings for timely completion within six months, ensuring accountability and fair process."
    },
    {
      icon: "Users",
      title: "Senior Advocate Dignity & Mentorship",
      description: "Facilitate knowledge sharing from senior advocates to train and guide junior advocates, preserving institutional knowledge."
    },
    {
      icon: "Heart",
      title: "Support Marginalized Advocates",
      description: "Work towards inclusivity for advocates with disabilities and rural backgrounds, ensuring equal opportunities for all."
    },
    {
      icon: "Baby",
      title: "Childcare Facilities",
      description: "Establish childcare centers and play areas for children of mother advocates, supporting work-life balance in the legal profession."
    }
  ],

  achievements: {
    image: "https://customer-assets.emergentagent.com/job_90bc38f9-3060-400d-9611-cbf37a877254/artifacts/42mp11e9_ChatGPT%20Image%20Jan%2027%2C%202026%2C%2012_45_26%20PM.png",
    title: "Key Achievements",
    items: [
      {
        title: "Secured 30% Women Reservation",
        description: "Played a decisive role in securing women's reservation at the Bar Council"
      },
      {
        title: "Historic Supreme Court Order",
        description: "Contributed to landmark orders benefiting women advocates nationwide"
      },
      {
        title: "National Recognition",
        description: "National Youth Award (HRD Govt. of India), Women Excellence Award, State Adarsha Mahila Puraskar 2019"
      },
      {
        title: "Educational Excellence",
        description: "Ph.D. in Law, LLM, PG Diploma in FDR from NALSAR, extensive arbitration training"
      },
      {
        title: "Community Impact",
        description: "Conducted legal awareness campaigns reaching 100+ schools and colleges across Telangana"
      },
      {
        title: "Active Mentorship",
        description: "Continuously mentors and guides women and junior advocates in their professional journey"
      }
    ]
  },

  contact: {
    title: "Join My Movement",
    subtitle: "Together, we can build a stronger, more inclusive legal profession",
    phone: ["+91 90599 95971", "+91 91778 64071"],
    address: "Flat 104 Gharonda Mahima Apartt, Padmarao Nagar, Secunderabad, Hyderabad - 500020",
    ctaText: "Connect With Me"
  },

  motto: "JUSTICE. DIGNITY. REFORM."
};
